// extracted by mini-css-extract-plugin
export default {"wrapper":"denied_wrapper__OO+NP"};